
import { Vue, Component, Prop } from "vue-property-decorator";
import { colorData } from "./colorData";
import cloneDeep from "lodash/cloneDeep";
interface ColorOption {
  label: string;
  value: string;
  checked?: boolean;
}
@Component
export default class ColorPanel extends Vue {
  @Prop({ required: false, default: () => ({}) })
  props?: {
    label?: string;
    value?: string;
  };
  generalOptions: ColorOption[] = [];
  checkedColors: ColorOption[] = [];
  customColor = "";
  get valueKey(): keyof ColorOption {
    return (this.props?.value || "value") as keyof ColorOption;
  }
  get labelKey() {
    return (this.props?.label || "label") as keyof ColorOption;
  }
  created() {
    this.generalOptions = colorData.map((ele) => ({
      label: ele.text,
      value: ele.color,
      checked: false,
    }));
  }
  isWhiteColor(color: string) {
    return [
      "#fff",
      "#ffffff",
      "rgb(255,255,255)",
      "rgba(255,255,255,1)",
    ].includes(color.toLowerCase().replace(/\s/g, ""));
  }
  isColor(val: string) {
    const hashReg = /^#[0-9a-fA-F]{3,6}$/;
    const rgbReg =
      /^rgb[a]?\(((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))),){2}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))(,(1|(0\.\d+)))?\)$/;
    return (
      hashReg.test(val.trim()) ||
      rgbReg.test(val.replace(/\s/g, "").toLocaleLowerCase())
    );
  }
  toggleCheck(option: ColorOption, value?: boolean) {
    if (value !== undefined) {
      option.checked = value;
      return;
    }
    option.checked = !option.checked;
    if (option.checked) {
      this.addCheckedColor(option);
    } else {
      this.cancelCheckedColor(option);
    }
  }
  addCheckedColor(colorOption: ColorOption) {
    this.checkedColors.push(colorOption);
    this.emitChange();
  }
  cancelCheckedColor(colorOption: ColorOption) {
    this.checkedColors = this.checkedColors.filter(
      (ele) => ele !== colorOption
    );
    this.emitChange();
  }
  removeColor(colorOption: ColorOption) {
    this.checkedColors = this.checkedColors.filter(
      (ele) => ele !== colorOption
    );
    const generalIndex = this.generalOptions.indexOf(colorOption);
    if (generalIndex >= 0) {
      colorOption.checked = false;
    }
    this.emitChange();
  }
  removeColorByValue(value: string) {
    const colorOption = this.checkedColors.find(
      (ele) => ele[this.valueKey] === value
    );
    if (colorOption) {
      this.removeColor(colorOption);
    }
  }
  setCheckedValues(values: string[]) {
    values.forEach((value) => {
      const matchGeneralOption = this.generalOptions.find(
        (ele) => ele[this.valueKey] === value
      );
      if (matchGeneralOption && !matchGeneralOption.checked) {
        matchGeneralOption.checked = true;
        this.addCheckedColor(matchGeneralOption);
      } else if (!matchGeneralOption) {
        this.addCustomColor(value);
      }
    });
  }
  handleCustomColorPickerChange(val: string) {
    this.customColor = val;
  }
  handleCustomValueInputEnter() {
    this.addCustomColor(this.customColor);
  }
  addCustomColor(color: string) {
    if (!color) {
      return;
    }
    if (!this.checkedColors.some((ele) => ele.value === color)) {
      this.checkedColors.push({
        label: color,
        value: color,
      });
      this.emitChange();
    }
  }
  emitChange() {
    this.$emit("change", this.getSelection());
  }
  getSelection() {
    return cloneDeep(
      this.checkedColors.map((ele) => ({
        label: ele[this.labelKey],
        value: ele[this.valueKey],
      }))
    );
  }
}
